<script setup>
import {onMounted, ref, watch} from "vue";
import Repository from "../Helpers/Repository";
import FeaturedImage from "../Helpers/FeaturedImage";
import Api from "../Helpers/Api";
import {useI18n} from "vue-i18n";
import Language from "../Helpers/Language";
import Arr from "../Helpers/Arr";

const props = defineProps(['activeSpeakerSlug']);

const emits = defineEmits(['closeModal', 'changeSpeaker']);

const cannotOpenModal = ref(false);
const speakerData = ref({});
let modalContainer = null;
const {t} = useI18n();

watch(() => {
    if (props.activeSpeakerSlug !== null) {
        if (props.activeSpeakerSlug === speakerData.value['slug'] ?? null) {
            cannotOpenModal.value = true;
            return;
        }

        new Repository().getSpeaker(props.activeSpeakerSlug).then((response) => {
            let data = response.data[0];

            if ('speeches' in data && data['speeches'].length > 0) {
                data['speeches'] = Arr.sortByDateKey(data['speeches'], 'start');
            }

            speakerData.value = data;
            cannotOpenModal.value = true;
            modalContainer.scrollTo(0, 0);
        });
    }
})

const closeModal = () => {
    cannotOpenModal.value = false;
    emits('closeModal');
}

const formatScheduleDate = (schedule) => {
    const dateOptions = {hour: "numeric", minute: "numeric"};
    return new Date(schedule['start']).toLocaleTimeString(Language.getLanguage() ?? null, dateOptions)
        + 'h '
        + 'às '
        + new Date(schedule['end']).toLocaleTimeString(Language.getLanguage() ?? null, dateOptions)
        + 'h';
}

onMounted(() => {
    document.getElementById('modal').addEventListener('click', function (event) {
        if (event.target === this) {
            closeModal();
        }
    });

    modalContainer = document.querySelector('#modal > .container');
});

</script>

<template>
    <div id="modal" :class="{open: cannotOpenModal}">
        <div class="container">
            <button id="close_modal" @click="closeModal">&#10006;</button>
            <section>
                <figure>
                    <picture><img :src="FeaturedImage.getSpeakerFeaturedImageUrl(speakerData, false)" alt=""></picture>
                </figure>
                <div>
                    <span>{{t('Palestrante')}}</span>
                    <h1>{{ speakerData['name'] }}</h1>
                    <h3>{{ speakerData['bio'] }} | {{speakerData['company']}}</h3>
                    <p v-html="speakerData['description']"></p>
                </div>
            </section>
            <!--            <ul>-->
            <!--                <li>-->
            <!--                    <button @click="closeModal">Ver outros palestrantes</button>-->
            <!--                </li>-->
            <!--                <li>-->
            <!--                    <button class="secondary"><span>&#8618;</span>Compartilhar</button>-->
            <!--                </li>-->
            <!--            </ul>-->

            <section v-if="'speeches' in speakerData && speakerData['speeches'].length > 0">
                <h1>{{t('Confira as palestras')}}</h1>
                <ul>
                    <li v-for="schedule in speakerData['speeches']">
                    <span>{{
                            new Date(schedule['start']).toLocaleDateString(Language.getLanguage() ?? null, {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            })
                        }}</span>
                        <div>
                            <div>
                                <h1>{{ schedule['title'] }}</h1>
                                <div>
                                    <span v-if="schedule['stage']">
                                    <img :src="new Api().mountImageRootPath('localization.svg')" alt="Localization icon">
                                    {{ schedule['stage'] }}
                                    </span>
                                    <span>
                                    <img :src="new Api().mountImageRootPath('clock.svg')" alt="Clock icon">
                                    {{ formatScheduleDate(schedule) }}
                                    </span>
                                </div>
                                <ul>
                                    <li v-for="tag in schedule.tags">
                                        <span>{{ tag }}</span>
                                    </li>
                                </ul>
                            </div>
                            <ul>
                                <li v-for="speaker in schedule['speakers']">
                                    <a :href="`#${speaker['slug']}`" @click="$emit('changeSpeaker', speaker['slug'])">
                                        <figure>
                                            <picture>
                                                <img :src="FeaturedImage.getSpeakerFeaturedImageUrl(speaker)" alt="">
                                            </picture>
                                        </figure>
                                        <div>
                                            <h3>{{ speaker['name'] }}</h3>
                                            <h4>{{ speaker['bio'] }}<br><b>{{ speaker['company'] }}</b></h4>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </section>
        </div>
    </div>
</template>

<style scoped>

</style>
